import {
  useEffect, useState,
} from 'react';
import { getOptimizedTerritoriesProgressForStatus } from '~/_shared/components/topUnderbar/optimizedTerritoriesProgress/optimizedTerritoriesProgressBar.helpers';
import type { BoundaryCreateOptimizedStatus } from '~/store/frontendState/mapTools/boundary/boundaryCreateOptimized/boundaryCreateOptimized.state';

export const useOptimizedTerritoriesProgressForStatus = (status: BoundaryCreateOptimizedStatus) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const newProgress = getOptimizedTerritoriesProgressForStatus(status);
    if (newProgress < progress) {
      return;
    }

    setProgress(newProgress);
  }, [progress, status]);

  return progress;
};
